import { render } from "./RightSidebarItems.vue?vue&type=template&id=7e89d542&scoped=true"
import script from "./RightSidebarItems.vue?vue&type=script&lang=js"
export * from "./RightSidebarItems.vue?vue&type=script&lang=js"

import "./RightSidebarItems.vue?vue&type=style&index=0&id=7e89d542&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e89d542"]])

export default __exports__